import { createAction } from '@ngrx/store';

// Page Loading
export const setPageLoading = createAction('[COMMON] Set page loading');
export const resetPageLoading = createAction('[COMMON] Reset page loading');

// Sidebar
export const toggleSidebar = createAction('[COMMON] Toggle sidebar');
export const setSidebarCollapsed = createAction('[COMMON] Set sidebar collapsed', (collapsed: boolean) => ({
  collapsed,
}));
